// @flow

export const addHash = (str: string) => `#${str}`
export const addRef = (str: string) => `${str}-ref`



// WEBPACK FOOTER //
// ./src/components/typography/endnotes/endnotes.service.js